export { PromoBar, fetchPromoBar } from './PromoBar';
export type { PromoBarContentType } from './PromoBar';
